var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.loading
    ? _c(
        "div",
        {
          staticClass: "cog-field__placeholder cog-input cog-lookup--loading",
          class: { "is-read-only": _vm.readonly }
        },
        [
          _c(
            "div",
            { staticClass: "cog-field__placeholder-inner" },
            [_vm._v("\n\t\t \n\t\t"), _c("i-cog")],
            1
          )
        ]
      )
    : _c(
        "div",
        { staticClass: "cog-choice cog-lookup" },
        [
          _vm._t("default", null, {
            data: _vm.slot,
            choiceOptions: _vm.choiceOptions
          })
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }